enum UserIntegrationStatisticsType {
  totalErrors = 1,
  newUsers = 2,
  updatedUsers = 3,
}

export default UserIntegrationStatisticsType;
